import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLoop = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="M32 16.146c0 7.782-5.585 14.282-12.957 15.708v-5.183c4.567-1.322 7.916-5.539 7.916-10.525 0-6.043-4.916-10.96-10.959-10.96-6.043 0-10.959 4.917-10.959 10.96 0 1.628.348 3.192 1.033 4.652L1.51 22.94A15.869 15.869 0 0 1 0 16.146c0-8.823 7.177-16 16-16s16 7.177 16 16z" /></g></svg>;
export default SvgLoop;